import React from 'react';
import PropTypes from "prop-types";

const ModalDeletePerson = ({ hideModalDelete, showDeleteUser, deleteUserConfirmation, userId}) => {
    return(
        <div
            className={`bootbox modal fade bootbox-confirm ${showDeleteUser && "in"}`}
            tabIndex="-1"
            role="dialog"
            style={{
                display: showDeleteUser ? "block": "none",
                paddingRight: 15
            }}
        >
            <div className="modal-dialog modal-sm">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="bootbox-close-button close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            style={{marginTop: -10}}
                            onClick={() => hideModalDelete()}
                        >
                            ×
                        </button>
                        <div className="bootbox-body">
                            <div className="sp-10 font-16">
                                Do you really want to remove this user from your course?
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            data-bb-handler="cancel"
                            type="button"
                            className="btn btn-default"
                            onClick={() => hideModalDelete()}
                        >
                            CANCEL
                        </button>
                        <button
                            data-bb-handler="confirm"
                            type="button"
                            className="btn btn-danger"
                            onClick={() =>
                            {
                                hideModalDelete();
                                deleteUserConfirmation(userId);
                            }
                            }
                        >
                            DELETE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ModalDeletePerson.propTypes = {
    showDeleteUser: PropTypes.bool.isRequired,
    hideModalDelete: PropTypes.func.isRequired,
    deleteUserConfirmation: PropTypes.func.isRequired,
    userId: PropTypes.any.isRequired
};

export default ModalDeletePerson;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/People/ModalDeletePerson.js